export default "__VITE_PUBLIC_ASSET__bb562077__"